import { background, borderColor, brandPrimaryHover, inputBorderColor, navigation } from '../../../web/styles/colors';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	input: {
		display: 'none',
	},
	label: {
		':hover': {
			background: borderColor,
		},
		alignItems: 'center',
		background,
		border: `1px dashed ${inputBorderColor}`,
		borderRadius: '0.5rem',
		cursor: 'pointer',
		display: 'flex',
		flexDirection: 'column',
		height: '24rem',
		justifyContent: 'center',
		width: '100%',
	},
	labelInnerDiv: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		padding: '1.25rem 0',
	},
	noImagePlaceholder: {
		color: navigation,
		fontStyle: 'italic',
		fontSize: '0.875rem',
		marginBottom: '1rem',
	},
	previewImage: {
		display: 'block',
		maxHeight: '20rem',
	},
	root: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'center',
		width: '100%',
	},
	uploadImageLink: {
		color: brandPrimaryHover,
		fontSize: '0.875rem',
	},
});
